/** 工程看板的多选筛选：连续勾选团队、阶段或状态，空选择表示全部。
 * 复用 Radix 菜单的键盘与焦点管理；选中后保持展开，避免每选一项都要重新打开。
 */
import React from "react";
import { ChevronDown } from "lucide-react";
import { Button } from "./ui/button";
import { DropdownMenu, DropdownMenuTrigger, DropdownMenuContent, DropdownMenuCheckboxItem } from "./ui/dropdown-menu";

/** values 为已选值数组，options 提供 value/label，onChange 返回新数组。
 * allLabel 表示不限制范围；多项时以数量压缩按钮文字，完整选择仍可在菜单中查看。
 * testid 沿用原筛选器契约；className 用于列表与日历各自的控件尺寸。
 */
export default function BoardMultiSelect({ values, options, onChange, label, allLabel, testid, className = "h-9 w-36" }) {
  const selected = options.filter((option) => values.includes(option.value));
  const summary = selected.length === 0 ? allLabel : selected.length === 1 ? selected[0].label : `${label} (${selected.length})`;
  const fullLabel = selected.length ? selected.map((option) => option.label).join("、") : allLabel;
  // 多选后菜单会保持展开，使用非模态模式避免持续锁住工程列表的滚动与外部点击。
  return <DropdownMenu modal={false}>
    <DropdownMenuTrigger asChild>
      <Button type="button" variant="outline" data-testid={testid} title={fullLabel} aria-label={`${label}: ${fullLabel}`}
        className={`justify-between gap-2 px-3 font-normal ${className}`}>
        <span className="truncate">{summary}</span><ChevronDown aria-hidden="true" className="h-4 w-4 shrink-0 opacity-50" />
      </Button>
    </DropdownMenuTrigger>
    <DropdownMenuContent align="start" className="min-w-[12rem] max-w-[calc(100vw-2rem)]" aria-label={label}>
      <DropdownMenuCheckboxItem checked={!values.length} onCheckedChange={() => onChange([])} onSelect={(event) => event.preventDefault()}>
        {allLabel}
      </DropdownMenuCheckboxItem>
      {options.map((option) => <DropdownMenuCheckboxItem key={option.value} data-testid={`${testid}-opt-${option.value}`}
        checked={values.includes(option.value)} onSelect={(event) => event.preventDefault()}
        onCheckedChange={(checked) => onChange(checked ? [...values, option.value] : values.filter((value) => value !== option.value))}>
        {option.label}
      </DropdownMenuCheckboxItem>)}
    </DropdownMenuContent>
  </DropdownMenu>;
}
